/**
 * Shared password validation — used by both the API and the web frontend.
 * Keep in sync with the strength rules shown in PasswordStrengthBar.
 */

/**
 * Returns null when the password satisfies all requirements,
 * otherwise returns a human-readable Hungarian error message.
 */
export function validatePassword(pw: string): string | null {
  if (pw.length < 8)            return 'A jelszónak legalább 8 karakterből kell állnia.';
  if (!/[a-z]/.test(pw))        return 'A jelszónak kisbetűt kell tartalmaznia.';
  if (!/[A-Z]/.test(pw))        return 'A jelszónak nagybetűt kell tartalmaznia.';
  if (!/[0-9]/.test(pw))        return 'A jelszónak számot kell tartalmaznia.';
  if (!/[^a-zA-Z0-9]/.test(pw)) return 'A jelszónak speciális karaktert kell tartalmaznia.';
  return null;
}
